import React from 'react';
import { Icon } from 'semantic-ui-react';

function AdditionalInformation(props) {
	/*
        Props
            - url
    */

	if (!props.url || props.url === null) {
		return <span />;
	}

	return (
		<a href={props.url} target="_blank" className="info-link">
			<Icon name="info circle" />
		</a>
	);
}

export default AdditionalInformation;



// WEBPACK FOOTER //
// ./src/components/AdditionalInformation.js